<div class="card mt-3">
   <div class="card-body">
      <div class="d-flex align-items-center justify-content-between mb-2">
         <h5 class="card-title mb-0">Membership</h5>
         @if (subscription() && !isPendingCancellation() && !isPartnerBilled()) {
            <button type="button" class="btn btn-sm btn-site-outline-secondary" (click)="changePlan()">Change Plan</button>
         }
      </div>

      @if (isLoading()) {
         <div class="d-flex justify-content-center my-3">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
               <span class="visually-hidden">Loading...</span>
            </div>
         </div>
      } @else if (errorMessage()) {
         <div class="alert alert-danger my-3" role="alert">
            <strong>Unable to load membership.</strong>
            <div class="small">{{ errorMessage() }}</div>
         </div>
      } @else if (subscription()) {

         <!-- Always-visible summary -->
         <!-- Not showing this right now since info is on account-card already showing on page -->
         <!--<p class="card-text mb-1"><span class="fw-bold">Plan:</span> {{ productName() }}</p>
         <p class="card-text mb-3">
            <span class="fw-bold">Status:</span>
            <span class="fw-bold ms-1 {{ statusClass() }}">{{ statusDescription() }}</span>
         </p>-->

         <!-- Seat limit (multi-seat products only, editable inline) -->
         @if (isMultiSeatProduct()) {
         <div class="d-flex align-items-center gap-2 mb-3">
            @if (!isEditingSeatLimit()) {
               <span class="fw-bold">Seats:</span>
               <span>{{ seatsUsed() }} of {{ seatLimit() }} used</span>
               <button type="button" class="btn btn-sm btn-site-outline-secondary"
                       (click)="startEditSeatLimit()">Edit</button>
            } @else {
               <span class="fw-bold">Seat Limit:</span>
               <input type="number" class="form-control form-control-sm seat-limit-input"
                      [min]="minSeatLimit()" step="1"
                      [value]="seatLimitEdit()"
                      (input)="seatLimitEdit.set($any($event.target).valueAsNumber || null)" />
               <button type="button" class="btn btn-sm btn-success"
                       [disabled]="!canSaveSeatLimit() || seatLimitIsUpdating()"
                       (click)="confirmSeatLimit()">Save</button>
               <button type="button" class="btn btn-sm btn-outline-secondary"
                       [disabled]="seatLimitIsUpdating()"
                       (click)="cancelEditSeatLimit()">Never mind</button>
            }
         </div>
         }

         <!-- ===== STATUS / ENTRY ===== -->
         @if (step() === 'status') {

            @if (isPendingCancellation()) {
               <div class="alert alert-warning py-2 mb-3">
                  Membership will cancel on <strong>{{ cancellationEffective() | date:'MM/dd/yy' }}</strong>.
               </div>
               @if (canManage()) {
                  <button type="button" class="btn btn-sm btn-success"
                          (click)="startResume('undoCancel')">Don't Cancel &ndash; Resume Membership</button>
               }
            } @else if (isPendingPause()) {
               <div class="alert alert-warning py-2 mb-3">
                  Membership will pause on <strong>{{ nextPaymentDue() | date:'MM/dd/yy' }}</strong>
                  and remain paused until <strong>{{ pausedUntil() | date:'MM/dd/yy' }}</strong>.
               </div>
               <div class="d-flex flex-wrap gap-2">
                  @if (canManage()) {
                     <button type="button" class="btn btn-sm btn-success"
                             (click)="startResume('unpause')">Resume Membership</button>
                     <button type="button" class="btn btn-sm btn-site-outline-secondary"
                             (click)="startChange()">{{ changeEntryLabel() }}</button>
                  }
               </div>
            } @else if (isPaused()) {
               <div class="alert alert-warning py-2 mb-3">
                  Membership is paused and will resume on <strong>{{ pausedUntil() | date:'MM/dd/yy' }}</strong>.
               </div>
               <div class="d-flex flex-wrap gap-2">
                  @if (canManage()) {
                     <button type="button" class="btn btn-sm btn-success"
                             (click)="startResume('resume')">Resume Membership</button>
                     <button type="button" class="btn btn-sm btn-site-outline-secondary"
                             (click)="startChange()">{{ changeEntryLabel() }}</button>
                  }
               </div>
            } @else if (isActive()) {
               <!-- N -->
               <!--<p class="mb-3">Membership renews on <strong>{{ nextPaymentDue() | date:'MM/dd/yy' }}</strong>
               @if(nextPlannedSubscriptionConversionOption(); as option) {
                  to <strong>{{option.productDisplayName}}</strong>
               }.
               </p>-->
               @if (canPauseExtendCancelPlan()) {
                  <button type="button" class="btn btn-sm btn-site-outline-secondary"
                          (click)="startChange()">{{ changeEntryLabel() }}</button>
               } @else if (!isMonthly()) {
                  <p class="text-muted small mb-0"><em>Plan changes for this billing frequency ({{ billingFrequencyDescription() }}) aren't available here.</em></p>
               }
            } @else if (isOnHold()) {
               <div class="alert alert-warning py-2 mb-0">Membership is on hold due to an issue with the latest payment.</div>
            } @else if (isEnded()) {
               <div class="alert alert-secondary py-2 mb-0">Membership has ended.</div>
            } @else if (isCancelled()) {
               <div class="alert alert-secondary py-2 mb-0">Membership has been cancelled.</div>
            }

         }

         <!-- ===== CHOOSE CHANGE ===== -->
         @else if (step() === 'chooseChange') {
            <h6 class="border-top pt-3">Select an option:</h6>
            <div class="d-flex flex-column gap-2 mb-3">
               @for (option of changeOptions(); track option.key) {
                  <div class="form-check">
                     <input class="form-check-input" type="radio" name="membershipChange"
                            [id]="'change-' + option.key"
                            [checked]="selectedChange()?.key === option.key"
                            (change)="selectChange(option)" />
                     <label class="form-check-label" [for]="'change-' + option.key">{{ option.description }}</label>
                  </div>
               }
            </div>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="reset()">Never mind</button>
         }

         <!-- ===== CONFIRM PAUSE ===== -->
         @else if (step() === 'confirmPause') {
            @if (selectedChange(); as option) {
               <div class="alert alert-info py-2 mb-3">
                  @if (isPaused() || isPendingPause()) {
                     Membership will remain paused until <strong>{{ option.resumeDate }}</strong>.
                  } @else {
                     Membership will be paused as of <strong>{{ nextPaymentDue() | date:'MM/dd/yy' }}</strong>
                     and remain paused until <strong>{{ option.resumeDate }}</strong>.
                  }
               </div>
               <div class="d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-success"
                          [disabled]="isUpdating()" (click)="confirmPause()">Confirm</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary"
                          [disabled]="isUpdating()" (click)="startChange()">Back</button>
               </div>
            }
         }

         <!-- ===== CONFIRM CANCEL ===== -->
         @else if (step() === 'confirmCancel') {
            <div class="alert alert-danger py-2 mb-3">
               Are you sure you want to cancel? The member will lose all progress in the program.
            </div>
            <div class="d-flex gap-2">
               <button type="button" class="btn btn-sm btn-danger"
                       [disabled]="isUpdating()" (click)="proceedToCancelReason()">Yes, continue</button>
               <button type="button" class="btn btn-sm btn-outline-secondary"
                       [disabled]="isUpdating()" (click)="reset()">Never mind</button>
            </div>
         }

         <!-- ===== CHOOSE CANCEL REASON ===== -->
         @else if (step() === 'chooseCancelReason') {
            <h6 class="border-top pt-3">Select the reason for cancellation:</h6>
            <div class="d-flex flex-column gap-2 mb-3">
               @for (reason of cancellationReasons; track reason.code) {
                  <div class="form-check">
                     <input class="form-check-input" type="radio" name="cancellationReason"
                            [id]="'reason-' + reason.code"
                            [checked]="selectedCancelReasonCode() === reason.code"
                            (change)="selectCancelReason(reason.code)" />
                     <label class="form-check-label" [for]="'reason-' + reason.code">{{ reason.description }}</label>
                  </div>
                  @if (reason.code === CancellationReason_.FoundAlternative && showCancelReasonText()) {
                     <textarea class="form-control ms-4"
                               rows="2"
                               placeholder="Which alternative? (optional)"
                               [value]="cancelReasonText()"
                               (input)="cancelReasonText.set($any($event.target).value)"></textarea>
                  }
               }
            </div>
            <div class="d-flex gap-2">
               <button type="button" class="btn btn-sm btn-danger"
                       [disabled]="!canConfirmCancel() || isUpdating()" (click)="confirmCancel()">Confirm Cancellation</button>
               <button type="button" class="btn btn-sm btn-outline-secondary"
                       [disabled]="isUpdating()" (click)="reset()">Never mind</button>
            </div>
         }

         <!-- ===== CONFIRM RESUME ===== -->
         @else if (step() === 'confirmResume') {
            <div class="alert alert-info py-2 mb-3">
               @if (resumeKind() === 'unpause') {
                  Resuming will charge the regular scheduled payment on
                  <strong>{{ nextPaymentDue() | date:'MM/dd/yy' }}</strong> and the membership will resume.
               } @else if (resumeKind() === 'resume') {
                  Resuming will charge the payment method on file today. The new billing date going forward
                  will be based on today's payment.
               } @else if (resumeKind() === 'undoCancel') {
                  The membership will <strong>not</strong> be cancelled and will be charged the regular
                  scheduled payment on <strong>{{ cancellationEffective() | date:'MM/dd/yy' }}</strong>.
               }
            </div>
            <div class="d-flex gap-2">
               <button type="button" class="btn btn-sm btn-success"
                       [disabled]="isUpdating()" (click)="confirmResume()">Confirm Resume</button>
               <button type="button" class="btn btn-sm btn-outline-secondary"
                       [disabled]="isUpdating()" (click)="reset()">Never mind</button>
            </div>
         }

         @if (isUpdating() || seatLimitIsUpdating()) {
            <div class="d-flex align-items-center gap-2 mt-3 text-muted small">
               <div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Saving...</span></div>
               Saving&hellip;
            </div>
         }

      } @else {
         <p class="text-muted mb-0"><em>No membership information on file.</em></p>
      }
   </div>
</div>
